export default "__VITE_ASSET__BVj24Kc5__"